interface Props {
  position: any
  geometry: any
  material: any
  visible?: boolean
}

export const LedSpot = ({
  position,
  geometry,
  material,
  visible,
}: Props): JSX.Element => {
  return (
    <group dispose={null}>
      <mesh
        castShadow={false}
        receiveShadow={false}
        position={position}
        geometry={geometry}
        material={material}
        visible={visible}
      ></mesh>
    </group>
  )
}
